module.exports = __webpack_public_path__ + "static/media/Veske.8f76d658.PNG";